const Icon5 = ({className = '', ...props}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="65"
    height="65"
    fill="none"
    viewBox="0 0 65 65"
    className={className}
      {...props}
  >
    <path
      fill="url(#pattern0_111_1915)"
      d="M.527.171h64.704v64.704H.527z"
    ></path>
    <defs>
      <pattern
        id="pattern0_111_1915"
        width="1"
        height="1"
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#image0_111_1915" transform="scale(.01111)"></use>
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD50lEQVR4nO3dSYgVRxzH8XKLuAYXdEQUl4gEBUGYgxBBFA8ezGEwoEEvKiTEEUMC6sVlBDWQoB5kBAU9ORJFvUS9uCAugyIaCGTBFUMUxV3HXb9S2i6Mvoqvuqqruvv/gb7MY+pf/x8z8/p1VfcoJYQQQgghhBDCHvAJMBs4DFxLjkPATP1aiqHFa0AvoJnKTgB93nyDqB7QHjhpCPndsNtZlBAaUM/Hq3/5TaI6QM/kb/HHugH0rrKMANZRvcbQ884VYATwxCLop8Co0PPPDeAA9vRpX5vQPUQP+Ir0poTuI2pAJ+C8g6AvAp1D9xMtYDHuLArdT5SA/sA9h0HfBwaG7is6QBPubQ7dV1SAMcBzD0HrMceG7i8KQFvgOP7oayVtVdnx6vKnb7NUmQHdgEsZBH0F+FSVFfAL2flZlRHwGfAww6AfAcNV2QC7yN5vqkyAiYQzSZUB0AH4O2DQp4GOquiAHwnvB1VkQB/gZuiUgdtAjSoqYAPxWK+KCBgNPLMM5TugR4VDv2ZDz2W0KhrgIPa+MYz7bYpxjxRq2QuYRjrzDGN/n3LsqapAy1MXUoaxwDD+wpRj/wt0UXkHNJDeEsP4Sx2Mv1TlGTAAaHEQxApDjZWOlr0GqbwCtuLGKkON1Y5q/KryCPjC4fJUo+OtY5WMUzlcntJbaV3ZaKi1yWGd33O1/Tflue2HNBlqbcGtiufsUUk+rV113PwOQ72djmtd13cZqNgBa3Bvt6HeHg/1VquYAZ8Djz00vt/TztNK9JbhkSpWnn66tKOGmqYbidLYq2IEfIk/Jw11T3msO1lFeB/gPx4b/tNQ+y+Pdc9EteylL/rg1zlDbRf7qU3mqxgAfYFbnpu9ZKh/2XPtO0C/bFP1/8mskhuG+lmsQW7KNtX3m6xNsTxVDX3K+FOFw8fpZGu6x9pQIbdJ7oAqi+Ygy17ADMpnetYhdwX+o3wuA92zDHo55bU8q5CHAA8or0fAsCyC3h6owZZkaawhObY6Wo90etnWVcjjAzV2Qf8mfWA+Q5O7ZEOY4PNpMH8EamqaYV5fB5qTzqK9j6DnEM5gw7z6BZzXnNBPg3FtkGFuNQHnpZe9eroMei1hTfW4ry+tta5CHmn5NBjXb4ZDK9zZFerN0O2yl17SIQ73gW3AsuTYlnwtBvvShlwXuoMcqbMNuSNwNvTsc+Sc1bJXRjfDF81sm6D1A1dFdY7YBK2fjCiqc90m6LtVFhFw2yboY6FnnUPNNkHPDT3rHKq3Pb3zud2qaE5ZP509eRadhP3/dEb9rUJuta+uPllulzfIt3QWR5Ns5P8MCCGEEEIIIYQQQpXJC0GRVxBECPJfAAAAAElFTkSuQmCC"
        id="image0_111_1915"
        width="90"
        height="90"
        preserveAspectRatio="none"
      ></image>
    </defs>
  </svg>
);

export default Icon5;
